// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__sdoRO","window":"styles_window__O5xeb","wrapper":"styles_wrapper__Nps8e","title":"styles_title__sulqS","buttons":"styles_buttons__lHHwK"};